import { http } from './api';

const AWS = '/aws'

export function upload(data) {
    return http.post(AWS, data)
}

